import React from 'react';
import { BoolToString, ProtocolIButton } from 'components';
import { NavLink } from 'react-router-dom';
// import atoms from 'ctsutheme/components/atoms';
import { getTableColumns, getEncodedQueryParams } from 'helpers';

// const { Tooltip } = atoms;

const RenderProtocolLink = ({ data: { protocolNumber } }) => (
  <>
    <ProtocolIButton protocolNumber={protocolNumber} />
    <span className="mx-1 color-turquoise">|</span>
    <NavLink
      exact
      activeClassName="active"
      key={protocolNumber}
      to={getEncodedQueryParams(`protocol/`, `${protocolNumber}/protocoldetail`)}
    >
      {protocolNumber}
    </NavLink>
  </>
);


const ProtocolBrowserColumns = [
  {
    name: 'protocolNumber',
    align: 'left',
    type: 'string',
    label: 'Protocol #',
    filterable: true,
    renderCell: data => <RenderProtocolLink data={data} />
  },
  ...getTableColumns(
    [
      ['leadGrp', 'string', 'Lead Group', 'left', true, true],
      ['phase', 'string', 'Phase', 'center', true, true],
      ['activationDate', 'string', 'Activation Date', 'center', true, false],
      ['grpProtStatus', 'string', 'Group Protocol Status', 'left', true, true],
      ['grpProtStatusDate', 'string', 'Group Protocol Status Date', 'center', true, true],
      ['nihAdminCode', 'string', 'NIH Admin Code', 'left', true, true]
    ]
  ),
  {
    name: 'isCirbRequired',
    // type: 'string',
    label: 'CIRB Required',
    align: 'center',
    filterable: true,
    renderCell: data => <BoolToString boolValue={data.isCirbRequired} />
  },
  ...getTableColumns(
    [
      ['diseaseSite', 'string', 'CTSU Disease Term', 'left', true]
    ]
  ),
  {
    name: 'anticipatedPrimaryComplDate',
    type: 'string',
    label: 'APCD',
    // label: <Tooltip tooltipplacementbottom="true" title="Anticipated Primary Completion Date" className="sticky-header-tooltip-i-dark"><div>APCD</div></Tooltip>,
    align: 'center',
    filterable: true
  },
  {
    name: 'actualPrimaryComplDate',
    type: 'string',
    label: 'PCD',
    // label: <Tooltip tooltipplacementbottom="true" title="Primary Completion Date" className="sticky-header-tooltip-i-dark"><div>PCD</div></Tooltip>,
    align: 'center',
    filterable: true
  },
  ...getTableColumns(
    [
      ['indIdeType', 'string', 'IND/IDE Type', 'left', true]
    ]
  ),
  {
    name: 'isIrbExempt',
    label: 'IRB Exempt',
    align: 'center',
    filterable: true,
    renderCell: data => <BoolToString boolValue={data.isIrbExempt} />
  }
];

export default ProtocolBrowserColumns;
